import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Hammer from 'react-hammerjs';

import CarrousselItem from './carroussel-item';

const Container = styled.div`
  background: #DEDEDE;
  display: flex;
  width: 100%;
  margin-bottom: 16px;
  position: relative;
  overflow: hidden;
  @media (min-width: 1024px) {
    width: calc(70% - 16px);
    margin-bottom: 0;
    height: 500px;
  }
  @media (max-width: 1024px) {
    height: 420px;
  }
  @media (max-width: 540px) {
    height: 350px;
  }
  .holder {
    display: flex;
    width: 100%;
    height: 100%;
    transition: all 0.3s;
  }
  .item {
    height: 100%;
    background: #BDBDBD;
    width: 100%;
  }
`;

const Bullets = styled.ul`
  position: absolute;
  bottom: 14px;
  left: 0;
  right: 0;
  text-align: center;
  padding: 0;
  margin: 0;
  li {
    &.active {
      background: #fff;
    }
    border: 1px solid #fff;
    width: 10px;
    height: 10px;
    border-radius: 10px;
    margin: 0 3px;
    display: inline-block;
    cursor: pointer;
  }
`;

class Carroussel extends Component {
  state = {
    pos: 0,
    total: 0,
  }
  togglePos(event, pos) {
    this.setState({pos: pos});
    this.setTimer();
  }
  swipeHandle = (event, total) => {
    if (event.deltaX < 0 && this.state.pos < total) {
      this.setState({"pos": this.state.pos + 1})
    } else if(event.deltaX > 0 && this.state.pos > 0) {
      this.setState({"pos": this.state.pos - 1})
    }
    this.setTimer();
  }
  componentWillUnmount = () => {
    clearInterval(this.state.timer)
  }
  setTimer() {
    clearInterval(this.state.timer)
    this.setState({timer: setInterval(() => {
      this.setState({pos: this.state.pos < (this.state.total - 1) ? this.state.pos + 1 : 0})
    }, 6000)})
  }
  componentDidUpdate() {
    const { banners } = this.props;
    if (this.state.total !== banners.length) {
      this.setState({total: banners.length, pos: 0})
      this.setTimer();
    }
  }
  render = () => {
    const { banners } = this.props;
    return (
      <Container>
        <Hammer direction="DIRECTION_HORIZONTAL" onSwipe={ (e) => { this.swipeHandle(e, banners.length) } }>
          <div className="holder" style={ { transform: `translateX(-${this.state.pos * 100}%)` }}>
            {
              banners.map((item, index) => {
                return (
                  <CarrousselItem {...item} key={ index } />
                )
              })
            }
          </div>
        </Hammer>
        <Bullets>
          {
            banners.map((item, index) => {
              return (
                <li key={ index} className={ this.state.pos === index ? 'active' : '' } onClick={ (e) => { this.setState({pos: index })} }></li>
              )
            })
          }
        </Bullets>
      </Container>
    );
  }
}

Carroussel.propTypes = {
  dispatch: PropTypes.func,
  match: PropTypes.object,
  location: PropTypes.object,
};

export default Carroussel;
